import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ENVIRONMENT } from '@env/environment';
import { ExportPowerBIReport } from '@power-bi/models/export-power-bi-report';
import { ExportPowerBIReportOptions } from '@power-bi/models/export-power-bi-report-options';
import { ExportPowerBIReportStatus } from '@power-bi/models/export-power-bi-report-status';

@Injectable({ providedIn: 'root' })
export class PowerBIExportReportService {
  readonly #httpClient = inject(HttpClient);

  readonly #coreApiUrl = `${ENVIRONMENT.coreApi.endpoint}/powerbi/reports/export`;

  startExport(
    clientPowerBIReportId: string,
    exportReportOptions: ExportPowerBIReportOptions
  ): Observable<ExportPowerBIReport> {
    return this.#httpClient.post<ExportPowerBIReport>(
      `${this.#coreApiUrl}/start/${clientPowerBIReportId}`,
      exportReportOptions
    );
  }

  getStatusOfExport(
    exportPowerBIReport: ExportPowerBIReport
  ): Observable<ExportPowerBIReportStatus> {
    return this.#httpClient.post<ExportPowerBIReportStatus>(
      `${this.#coreApiUrl}/status`,
      exportPowerBIReport
    );
  }

  getDownloadInfo(exportPowerBIReport: ExportPowerBIReport): Observable<Blob> {
    return this.#httpClient.post(
      `${this.#coreApiUrl}/download`,
      exportPowerBIReport,
      { responseType: 'blob' }
    );
  }
}
